import { useState } from 'react';
import { Button } from '@mui/material';
import { West } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { shallow } from 'zustand/shallow';
import AbandonPlanFormDialog from '../../../../../shared/components/ResetStepperFormModal/AbandonPlanFormDialog';
import usePlanStore from '../../../../../store/planStore';
import { useCountriesDataStore } from '../../../../../store/countriesDataStore';
import { Countries } from '../../../../../shared/enums';
import country from '../../../Country/Country';

interface BackToListProps {
  goBackOnly?: boolean;
  sx?: object;
}

export default function BackToList({
  sx,
  goBackOnly = false,
}: BackToListProps) {
  const [resetDialog, setResetDialog] = useState({
    show: false,
  });

  const {
    resetGeneralInfoState,
    setIsPlanCreating,
    resetCountryForms,
    resetAllSavedCountryForms,
    resetSavedGeneralInfoState,
    setActiveTab,
    setSelectedCountry,
    setAlreadySavedPlanId,
    resetAllStoredCountryForms,
    resetComparedPlans,
    setIsLocked,
  } = usePlanStore();

  const countriesDataStore = useCountriesDataStore((state) => state, shallow);

  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleCloseResetDialog = () => {
    setResetDialog({ show: false });
  };

  const handleAbandonPlan = () => {
    resetSavedGeneralInfoState();
    setIsPlanCreating(false);
    resetGeneralInfoState();
    resetCountryForms();
    resetAllSavedCountryForms();
    resetAllStoredCountryForms();
    resetComparedPlans();
    setIsLocked(false);
    navigate('/');
    setSelectedCountry(null);
    setActiveTab('generalInfo');
    setAlreadySavedPlanId();
    Object.keys(Countries).forEach((availableCountry) => {
      countriesDataStore[
        Countries[availableCountry as keyof typeof Countries]
      ]?.updateOptionalIds({});
    });
  };
  return (
    <>
      {resetDialog.show && (
        <AbandonPlanFormDialog
          open
          onClose={handleCloseResetDialog}
          onSuccess={handleAbandonPlan}
        />
      )}
      <Button
        variant="text"
        onClick={() => {
          if (goBackOnly) {
            setIsPlanCreating(false);
            setSelectedCountry(null);
            resetGeneralInfoState();
            resetSavedGeneralInfoState();
            resetCountryForms();
            resetAllSavedCountryForms();
            resetAllStoredCountryForms();
            setAlreadySavedPlanId();
            setIsLocked(false);
            setActiveTab('generalInfo');
            Object.keys(Countries).forEach((availableCountry) => {
              countriesDataStore[
                Countries[availableCountry as keyof typeof Countries]
              ]?.updateOptionalIds({});
            });
            navigate('/');
          } else {
            setResetDialog({
              show: true,
            });
          }
        }}
        sx={{
          cursor: 'pointer',
          textTransform: 'none',
          paddingBottom: '16px',
          fontWeight: 700,
          ...sx,
        }}
      >
        <West sx={{ fontSize: 14, paddingRight: '8px' }} />
        {t('mediaPlanning.backToList')}
      </Button>
    </>
  );
}
